/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShipmentDto } from '../../models/shipment-dto';

export interface ShipmentControllerDelete$Params {
  id: string;
}

export function shipmentControllerDelete(http: HttpClient, rootUrl: string, params: ShipmentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipmentDto>> {
  const rb = new RequestBuilder(rootUrl, shipmentControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShipmentDto>;
    })
  );
}

shipmentControllerDelete.PATH = '/api/shipments/{id}';
